// extracted by mini-css-extract-plugin
module.exports = {"container":"Profile_container__1GDl3","avatar":"Profile_avatar__2cK2o","popup":"Profile_popup__2JDJH","item":"Profile_item__1cfvb"};